import script from "./ApTime.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApTime.vue?vue&type=script&lang=ts&setup=true"

import "./ApTime.vue?vue&type=style&index=0&id=5f3f6d8f&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f3f6d8f"]])

export default __exports__